import { GET_TITLE, SET_TITLE } from "./TitleType";

const getTitle = () => ({
    type: GET_TITLE,
});

const setTitle = (titleDropDownList: any) => ({
    type: SET_TITLE,
    titleDropDownList
});

export {
    getTitle,
    setTitle
}
